import styled from 'styled-components';

export default styled.p`
    white-space: pre-wrap;
    margin: 0;
`;
